import axios from "axios"
import { config } from "../../config"

// const getTransactions = (customer) => {
//     return new Promise((resolve, reject) => {
//         console.log(customer)
//         let params = ``;
//         // if ( input ) params += `input=${input}&` 
//         // if ( filters ) params += `filters=${filters}&` 
//         // if ( sorting ) params += `sorting=${sorting}` 
//         if( customer ) params += `customer=${customer}`
//         axios.get(`${config.GRIPHOOK_BACKEND_URL}/transactions/getTransactions?${params}`)
//         .then(res => {
//             resolve(res?.data?.data)
//         })
//         .catch(() => {
//             resolve(false);
//         })
//     })
// }

const getTransactions = (customer) => {
    return new Promise((resolve, reject) => {
        console.log(customer)
        let params = ``;
        // if ( input ) params += `input=${input}&` 
        // if ( filters ) params += `filters=${filters}&` 
        // if ( sorting ) params += `sorting=${sorting}` 
        if( customer ) params += `customer=${customer}`

        axios.get(`${config.GRIPHOOK_BACKEND_URL}/transactions/getStripeTransactions?${params}`)
        .then(res => {
            resolve(res?.data?.data)
        })
        .catch(() => {
            resolve(false);
        })
    })
}

const getInvoicesByQuestId = (customer, questId) => {
    return new Promise((resolve, reject) => {
        let params = ``;

        if( customer ) params += `customer=${customer}`
        if( questId ) params += `&questId=${questId}`


        axios.get(`${config.GRIPHOOK_BACKEND_URL}/transactions/getStripeTransactionsByQuest?${params}`)
        .then(res => {
            resolve(res?.data?.data)
        })
        .catch(() => {
            resolve(false);
        })
    })
}

const get_product_invoices = (customer, category, subscriptionId) => {
    return axios.get(`${config.GRIPHOOK_BACKEND_URL}/transactions/getStripeTransactionsByProduct`, {
        params: {customer, category, subscriptionId}
    })
    .then(res => res?.data)
    .catch(() => false)
}

const getStripeTransactionsCRM = (customer, subId) => {
    return new Promise((resolve, reject) => {
        let params = ``;

        if( customer ) params += `customer=${customer}`
        if( subId ) params += `&subId=${subId}`

        axios.get(`${config.GRIPHOOK_BACKEND_URL}/transactions/getStripeTransactionsCRM?${params}`)
        .then(res => {
            resolve(res?.data?.data)
        })
        .catch(() => {
            resolve(false);
        })
    })
}

export {
    getTransactions,
    getInvoicesByQuestId,
    get_product_invoices,
    getStripeTransactionsCRM
};
